module.exports = __webpack_public_path__ + "files/efaa9297a40717c11e1a80d69d644a82.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-bold-webfont.svg
 ** module id = 982
 ** module chunks = 0
 **/